import { render } from "./From.vue?vue&type=template&id=f34c9bd4&ts=true"
import script from "./From.vue?vue&type=script&lang=ts"
export * from "./From.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./From.vue?vue&type=custom&index=0&blockType=style.&lang=scss"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__